import { PriorityFilterEnum } from "app/types";
import React from "react";
import { GroupByTypeEnum } from "../../../../types";

// Components
import { ITickets } from "../../types";
import EffortActual from "../ColumnCustomize/EffortActual";
import EffortEstimated from "../ColumnCustomize/EffortEstimated";
import Assignee from "./Assignee";
import CreatedDate from "./CreatedDate";
import Creator from "./Creator";
import DueDateSelection from "./DueDateSelection";
import Environment from "./Environment";
import Priority from "./Priority";
import Release from "./Release";
import Severity from "./Severity";
import Sprint from "./Sprint";
import Status from "./Status";
import TicketTypeSelection from "./TicketType";
import { EffortEstimatedType } from "app/containers/Features/types";

interface Props {
  field: GroupByTypeEnum;
  ticket: ITickets;
  isSelected: boolean;
  onUpdate: (field: GroupByTypeEnum, value: any) => void;
}

const RowFieldRenderer: React.FC<Props> = ({
  field,
  ticket,
  isSelected,
  onUpdate,
}) => {
  let content: React.ReactNode = null;

  switch (field) {
    case GroupByTypeEnum.ASSIGNEE:
      content = (
        <Assignee
          assignedTo={ticket.assignedTo}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );
      break;

    case GroupByTypeEnum.STATUS:
      content = (
        <Status ticket={ticket} onUpdate={(id) => onUpdate(field, id)} />
      );
      break;

    case GroupByTypeEnum.TICKET_TYPE:
      content = (
        <TicketTypeSelection
          value={ticket.type}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );
      break;

    case GroupByTypeEnum.PRIORITY:
      content = (
        <Priority
          value={ticket.priority as PriorityFilterEnum}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );
      break;

    case GroupByTypeEnum.DUE_DATE:
      content = (
        <DueDateSelection
          value={ticket.dueDate}
          onUpdate={(id) => onUpdate(field, id)}
        />
      );
      break;

    case GroupByTypeEnum.RELEASE:
    case GroupByTypeEnum.TARGET_RELEASE:
      content = <Release value="" />;
      break;

    case GroupByTypeEnum.SEVERITY:
      content = <Severity value="" />;
      break;

    case GroupByTypeEnum.ENVIRONMENT:
      content = <Environment value="" />;
      break;

    case GroupByTypeEnum.SPRINT:
      content = <Sprint />;
      break;

    case GroupByTypeEnum.EFFORTS_ESTIMATION:
      content = (
        <EffortEstimated
          ticketDetail={ticket}
          onUpdate={(effortEstimated: EffortEstimatedType) =>
            onUpdate(field, [effortEstimated])
          }
        />
      );
      break;

    case GroupByTypeEnum.EFFORT_ACTUAL:
      content = <EffortActual ticketDetail={ticket} />;
      break;

    case GroupByTypeEnum.CREATOR:
      content = <Creator value={ticket.createdBy} />;
      break;

    case GroupByTypeEnum.CREATED_DATE:
      content = <CreatedDate value={ticket.createdDate} />;
      break;

    case GroupByTypeEnum.COMPONENT:
      content = (
        <div className="flex items-center p-[4px] min-w-[109px]">—</div>
      );
      break;

    default:
      return null;
  }

  return (
    <div
      className={`h-full flex items-center px-[4px] ${
        isSelected ? "bg-[#E7F1FF]" : ""
      }`}
    >
      {content}
    </div>
  );
};

export default RowFieldRenderer;
